import buildTableListDone from 'View/reschedule/const/tableListDone';
import buildTableListRequested from 'View/reschedule/const/tableListRequested';

const getTableList = (selectedTab, t, onOpenPreview) => {
  switch (selectedTab) {
    case 'requested':
      return buildTableListRequested(t, onOpenPreview);
    case 'done':
      return buildTableListDone(t, onOpenPreview);
    default:
      return buildTableListRequested(t, onOpenPreview);
  }
};

export default getTableList;
